import { createContext, useContext } from 'react';

import { SubscriptionPolicy } from '../../domain';

type FiltersContextState = {
  search: string;
  setSearch: (search: string) => void;
  subscriptionPolicies: SubscriptionPolicy[];
  toggleSubscriptionPolicy: (policy: SubscriptionPolicy) => void;
  subscriptionStatuses: boolean[];
  toggleSubscriptionStatus: (status: boolean) => void;
  mediums: string[];
  toggleMedium: (status: string) => void;
  clearFilters: (() => void) | null;
};

export const defaultState = {
  search: '',
  setSearch: () => null,
  subscriptionPolicies: [],
  subscriptionStatuses: [],
  mediums: [],
  toggleSubscriptionPolicy: () => null,
  toggleSubscriptionStatus: () => null,
  toggleMedium: () => null,
  clearFilters: null,
};

export const FiltersContext = createContext<FiltersContextState>(defaultState);

export const useFiltersContext = () => useContext(FiltersContext);
